import { getFAQs } from 'services/faqs/getFAQs';
import { hideLoader, showErrorResponseModal, showLoader } from '../commons';
import { FETCH_FAQS, FETCH_FAQS_FAILED, FETCH_FAQS_SUCCESS } from './type';

export const fetchFAQsSuccess = (payload) => ({
  type: FETCH_FAQS_SUCCESS,
  payload,
});

export const fetchFAQsFailed = (payload) => ({
  type: FETCH_FAQS_FAILED,
  payload,
});

export const fetchFAQs =
  ({ withLoader = true, ...payload } = {}) =>
  (dispatch, state) => {
    if (withLoader) dispatch(showLoader());

    dispatch({ type: FETCH_FAQS, payload });

    const { incrementalList = false } = payload;

    const { params = {} } = state.faqs.listOfFAQs;
    getFAQs(params)
      .then(([faqs]) => {
        dispatch(fetchFAQsSuccess({ ...faqs, incrementalList }));
      })
      .catch((error) => {
        console.error('error', error);
        // if (withLoader) dispatch(showErrorResponseModal(error));
        dispatch(fetchFAQsFailed(error));
      })
      .finally(() => {
        if (withLoader) dispatch(hideLoader());
      });
  };
